module.exports = __webpack_public_path__ + "static/img/pixan1_5.1fa315f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pixan1_5.png
// module id = RpKQ
// module chunks = 125